import { graphql, createRefetchContainer } from 'react-relay';
import PaymentsGraph from './PaymentsGraph';

export default createRefetchContainer(PaymentsGraph,
  {
    viewer: graphql`
      fragment PaymentsGraphContainer_viewer on User
        @argumentDefinitions(
          completed_payments_after: { type: "ISO8601Type" }
          completed_payments_before: { type: "ISO8601Type" }
          outstanding_payments_after: { type: "ISO8601Type" }
          outstanding_payments_before: { type: "ISO8601Type" }
          refunds_after: { type: "ISO8601Type" }
          refunds_before: { type: "ISO8601Type" }
        ) {
        s_time_zone
        completed_payments (
          before_time: $completed_payments_before
          after_time: $completed_payments_after
          first: 99999
        ) @connection(key: "PaymentsGraph_completed_payments") {
          edges {
            node {
              ... on CashPayment {
                id
                amount_cents
                amount_currency
                paid_at
              }
              ... on CheckPayment {
                id
                amount_cents
                amount_currency
                paid_at
              }
              ... on CustomPayment {
                id
                amount_cents
                amount_currency
                paid_at
              }
              ... on SquarePayment {
                id
                amount_cents
                amount_currency
                paid_at
              }
            }
          }
        }
        outstanding_payments (
          before_time: $outstanding_payments_before
          after_time: $outstanding_payments_after
          first: 99999
        ) @connection(key: "PaymentsGraph_outstanding_payments") {
          edges {
            node {
              id
              amount_cents
              amount_currency
              payment_date
            }
          }
        }
        refunds (
          before_time: $refunds_before
          after_time: $refunds_after
          first: 99999
        ) @connection(key: "PaymentsGraph_refunds") {
          edges {
            node {
              id
              amount_cents
              amount_currency
              refunded_at
            }
          }
        }
      }`
  },
  graphql`
    query PaymentsGraphContainer_RefethQuery(
      $completed_payments_before: ISO8601Type
      $completed_payments_after: ISO8601Type
      $outstanding_payments_before: ISO8601Type
      $outstanding_payments_after: ISO8601Type
      $refunds_before: ISO8601Type
      $refunds_after: ISO8601Type
    ) {
      viewer {
        ...PaymentsGraphContainer_viewer @arguments(
          completed_payments_before: $completed_payments_before
          completed_payments_after: $completed_payments_after
          outstanding_payments_before: $outstanding_payments_before
          outstanding_payments_after: $outstanding_payments_after
          refunds_before: $refunds_before
          refunds_after: $refunds_after
        )
      }
    }
  `
);



// WEBPACK FOOTER //
// ./webpack/components/Financial/PaymentsGraph/PaymentsGraphContainer.js